import { render } from "./PaginaHome.vue?vue&type=template&id=23139fbc&scoped=true"
import script from "./PaginaHome.vue?vue&type=script&lang=js"
export * from "./PaginaHome.vue?vue&type=script&lang=js"

import "./PaginaHome.vue?vue&type=style&index=0&id=23139fbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23139fbc"]])

export default __exports__